import { HomePage } from '@/views/Home';
import NotFoundPage from '@/views/NotFound/NotFoundPage';
import PrintLabels from '@/views/Labels/PrintLabels';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CreateLabels from '@/views/Labels/CreateLabels';
import PrintSerials from '@/views/Labels/PrintSerials';
import CreateSerialLabels from '@/views/Labels/CreateSerialLabels';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/labels_create' element={<CreateLabels />} />
        <Route path="/print_labels" element={<PrintLabels />} />
        <Route path="/print_serials" element={<PrintSerials />} />
        <Route path="/create_serial_labels" element={<CreateSerialLabels />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
